import { render, staticRenderFns } from "./RegisteredCard.vue?vue&type=template&id=aeee687c&scoped=true"
import script from "./RegisteredCard.vue?vue&type=script&lang=js"
export * from "./RegisteredCard.vue?vue&type=script&lang=js"
import style0 from "./RegisteredCard.vue?vue&type=style&index=0&id=aeee687c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeee687c",
  null
  
)

export default component.exports